import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useClient = (teamId: string | undefined) => {
	return useQuery({
		queryKey: ["partner", "clients", teamId],
		queryFn: () => partnerApiService.getTeam(teamId as string),
		enabled: !!teamId,
	});
};
